// extracted by mini-css-extract-plugin
export default {"entityMissing":"EntityNameDisplay_entityMissing__4rNtr"};